<i18n>
{
  "en": {
    "edit": "Edit",
    "new": "Unconfigurated",
    "revenueManaged": "Managed",
    "outOfStock": "Out of stock",
    "menuEnabled": "Menu enabled",
    "subordinate": "Sale format",
    "noNameError": "Product name not found"
  },
  "es": {
    "edit": "Editar",
    "new": "Sin configurar",
    "revenueManaged": "Gestionado",
    "outOfStock": "Fuera de stock",
    "menuEnabled": "Activo en menú",
    "subordinate": "Formato de venta",
    "noNameError": "Producto sin nombre"
  }
}
</i18n>

<template>
  <dynameat-row
    :title="masterProductTitle"
    :button-config-list="buttonConfigList"
    :collapse-items="collapseItems"
    @click-content="onEdit"
    @edit="onEdit">
    <template v-slot:aboveContent>
      <v-row align="center" class="chip-top">
        <v-chip v-if="isOutOfStock" x-small class="chip">{{ $t('outOfStock') }}</v-chip>
        <v-chip v-if="isNew" x-small class="chip">{{ $t('new') }}</v-chip>
        <v-chip v-if="isMenuEnabled" x-small class="chip">{{ $t('menuEnabled') }}</v-chip>
        <v-chip v-if="isRevenueManaged" x-small class="chip">{{ $t('revenueManaged') }}</v-chip>
        <v-chip v-if="isSubordinate" x-small class="chip">{{ $t('subordinate') }}</v-chip>
      </v-row>
    </template>
  </dynameat-row>
</template>

<script>

import DynameatRow from '@dynameat/components/DynameatRow';
import { Prop } from 'vue-property-decorator';
import Vue from 'vue';
import {Components, MapGetters} from '@core/helpers/decorators';
import Component from 'vue-class-component';
import { Product } from '@dynameat/views/pointOfSale/models';

@Component
@Components({ DynameatRow })
@MapGetters(['currency'])
export default class MasterProductRow extends Vue {
    @Prop({
      Object,
      validator(product) {
        return product instanceof Product;
      },
    }) product;

    @Prop({ type: Boolean, default: false }) isSubordinate;

    get buttonConfigList() {
      return [{
        title: `${this.$t('edit')}`,
        icon: 'mdi-pencil',
        emitName: 'edit'
      }];
    }

    get masterProductTitle() {
      return `${this.commercialName} (${this.product.id_external}) - (${this.currencyWithSymbol})`;
    }

    get currencyWithSymbol() {
      const amount = this.product.first_price;
      const { symbol } = this.currency;
      const left = this.currency.hasLeftPosition();
      return (left ? [symbol, amount] : [amount, symbol]).join(' ');
    }

    get commercialName() {
      return (this.product.commercial_name) || (this.product.name) || this.$t('noNameError');
    }

    get commercialDescription() {
      const desc = this.product.commercial_description;
      if (desc) return desc.substr(0, 32) + (desc.length > 33 ? '...' : '');
      return (this.product.commercial_description) || this.$t('noDescriptionError');
    }

    get isOutOfStock() {
      return this.product.out_of_stock;
    }

    get isMenuEnabled() {
      return this.product.is_menu_enabled;
    }

    get isNew() {
      return this.product.is_new;
    }

    get isRevenueManaged() {
      return this.product.is_managed;
    }

    get collapseItems() {
      return this.buttonConfigList.length > 1;
    }

    onEdit() {
      this.$emit('edit', this.product);
    }
}
</script>

<style scoped lang="scss">
.chip-top {
  margin-top: 5px;
  margin-left: 0;
}

.chip {
  margin-top: 5px;
  margin-right: 5px;
}

.v-list-item__action--stack {
  align-items: center;
}

.v-list-item__action--stack > .v-icon.v-icon {
  font-size: large;
}

</style>
